import { render, staticRenderFns } from "./DownloadFilesDialog.vue?vue&type=template&id=56df4a00&"
import script from "./DownloadFilesDialog.vue?vue&type=script&lang=js&"
export * from "./DownloadFilesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports